/* eslint-disable react/jsx-props-no-spreading */
import { LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { Suspense } from 'react';

import type { FC } from 'react';

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: theme.zIndex.appBar + 100,
  width: '100%',
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Loadable = (Component: FC) =>
  // eslint-disable-next-line func-names
  function (props: any) {
    return (
      <Suspense fallback={<StyledLinearProgress color="primary" />}>
        <Component {...props} />
      </Suspense>
    );
  };

export default Loadable;
